/* eslint-disable class-methods-use-this */
class ScrollUtils {
  _scrollTop = 0;

  _scrollLeft = 0;

  viewportHeight = 0;

  viewportWidth = 0;

  setScrollTop(scrollTop) {
    this._scrollTop = scrollTop;
  }

  setScrollLeft(scrollLeft) {
    this._scrollLeft = scrollLeft;
  }

  calculateFirstRow = (scrollTop, cellHeight) => scrollTop / cellHeight;

  calculateFirstCell = (scrollLeft, cellWidth) => scrollLeft / cellWidth;

  calculateCellHeight = (viewOptions) => viewOptions.cellHeight;

  calculateCellWidth = (viewOptions) => viewOptions.cellWidth;
}

export default new ScrollUtils();
